module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "priceContainer"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencyPrefix'))
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": _vm.identifier
    }
  }, [_vm._v(_vm._s(_vm.parsePrice(_vm.price)))]), _vm._v(" "), (!_vm.currencySuffixVersion || _vm.currencySuffixVersion == '1') ? _c('span', {
    staticClass: "prefix",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencySuffix'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currencySuffixVersion && _vm.currencySuffixVersion == '2') ? _c('span', {
    staticClass: "prefix",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('currencySuffixBuy'))
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d0c4d66!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/Price.vue
// module id = 168
// module chunks = 0